import wave from "../../assets/images/bg/wave-bg.png";
import { QRCodeCanvas } from "qrcode.react";

const ContactInner = () => {
  const address = "National Public School, Kudlu, Bengaluru, Karnataka 560068";

  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address,
  )}`;

  return (
    <>
      <section className="contact py-80">
        <div className="container">
          <div className="section-heading text-center">
            <div className="flex-align d-inline-flex gap-8 mb-16">
              <h5 className="text-main-600 mb-0">Get In Touch</h5>
            </div>

            <p className="">
              Have questions about admissions, curriculum, or school life at
              NPS, Kuldu? Our team is here to guide you. Reach out to us today
              and take the first step towards your child’s bright future.
            </p>
          </div>
          <div className="row gy-4">
            <div className="col-xl-4 col-md-6">
              <div className="contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600">
                <span className="contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0">
                  <i className="ph ph-map-pin-line" />
                </span>
                <div className="flex-grow-1">
                  <h4 className="mb-12">Address</h4>
                  <p className="text-neutral-500">
                    148, Silver County Rd, Kudlu, Singasandra, Bengaluru,
                    Karnataka – 560068
                  </p>

                  {/* Get Directions Button */}
                  <button
                    onClick={() => window.open(mapUrl, "_blank")}
                    className="btn btn-main rounded-pill mt-16"
                  >
                    Get Directions
                  </button>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600">
                <span className="contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0">
                  <i className="ph ph-envelope-open" />
                </span>
                <div className="flex-grow-1">
                  <h4 className="mb-12">Email</h4>
                  <p className="text-neutral-500">
                    <a href="mailto:info@npskudlu.com">info@npskudlu.com</a>
                    <br />
                    &nbsp;
                    <br />
                    &nbsp;<br></br>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600">
                <span className="contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0">
                  <i className="ph ph-phone-call" />
                </span>
                <div className="flex-grow-1">
                  <h4 className="mb-12">Contact Number</h4>
                  <p className="text-neutral-500">
                    <a href="tel:+919731226002">+91 97312 26002</a>
                    <br />
                    &nbsp;
                    <br />
                    &nbsp;<br></br>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-form-section py-160 bg-main-25 position-relative z-1">
        <img
          src={wave}
          alt=""
          className="position-absolute top-0 start-0 w-100 h-100 z-n1 d-lg-block d-none"
        />
        <div className="container">
          <div className="row gy-5 align-items-center">
            <div className="col-xl-7 col-lg-6 pe-lg-5">
              <div className="mb-40 md-xl-5">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d497826.168840939!2d77.668769!3d12.890549!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae139e51d557e5%3A0xc499e62ff7625a06!2sNational%20Public%20School%2C%20Kudlu!5e0!3m2!1sen!2sin!4v1760606545714!5m2!1sen!2sin"
                  width="100%"
                  height="600"
                  style={{ border: "0" }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="p-24 bg-white rounded-12 box-shadow-md">
                <div className="border border-neutral-30 rounded-8 bg-main-25 p-24">
                  <form action="" id="commentForm">
                    <h4 className="mb-0">Get In Touch</h4>
                    <span className="d-block border border-neutral-30 my-24 border-dashed" />
                    <div className="mb-24">
                      <label
                        htmlFor="name"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        className="common-input rounded-pill border-transparent focus-border-main-600"
                        id="name"
                        placeholder="Enter Name..."
                      />
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="email"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Email{" "}
                      </label>
                      <input
                        type="email"
                        className="common-input rounded-pill border-transparent focus-border-main-600"
                        id="email"
                        placeholder="Enter Email..."
                      />
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="phone"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Mobile
                      </label>
                      <input
                        type="tel"
                        className="common-input rounded-pill border-transparent focus-border-main-600"
                        id="phone"
                        placeholder="Enter Your Mobile Number..."
                      />
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="desc"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Message
                      </label>
                      <textarea
                        id="desc"
                        className="common-input rounded-24 border-transparent focus-border-main-600 h-110"
                        placeholder="Enter Your Message..."
                        defaultValue={""}
                      />
                    </div>
                    <div className="mb-0">
                      <button
                        type="submit"
                        className="btn btn-main rounded-pill flex-center gap-8 mt-40"
                      >
                        Submit
                        <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInner;
